/**
 * Every axios instance was created without a timeout, and axios defaults to none: a request
 * that stalls never settles, so the screen spins forever instead of surfacing an error. Two
 * minutes leaves room for a multi-page KYC document on a poor connection while still failing
 * in a bounded time.
 */
export const API_TIMEOUT_MS = 120000;
